import { PaStatus } from "../../../../enums/paStatus";

/**
 * Returns whether the Summary "View" action should be disabled for an Astera Oncology External row.
 * Disabled only while the outcome is still in progress or pending with insurance.
 *
 * @input responseStatus - Raw `response_status` from the row
 * @return boolean: True when the View button should be disabled
 */
export const isAsteraOutcomeViewDisabled = (
  responseStatus: string | null | undefined,
): boolean => {
  if (responseStatus == null || responseStatus === "") {
    return true;
  }
  return responseStatus === PaStatus.PENDING;
};
